// ===================================
// VALIDATORS UTILITY
// Form validation functions
// ===================================

class Validators {
  /**
   * Check if email is valid
   */
  isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  /**
   * Check if phone number is valid
   */
  isValidPhone(phone) {
    const phoneRegex = /^[\+]?[1-9][\d\s\-\(\)]{7,15}$/;
    return phoneRegex.test(phone.replace(/\s/g, ""));
  }

  /**
   * Check if date is in the future
   */
  isValidFutureDate(dateString) {
    const selectedDate = new Date(dateString);
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    tomorrow.setHours(0, 0, 0, 0);

    return selectedDate >= tomorrow;
  }

  /**
   * Check if string has minimum length
   */
  hasMinLength(str, minLength) {
    return str.trim().length >= minLength;
  }

  /**
   * Check if string has maximum length
   */
  hasMaxLength(str, maxLength) {
    return str.trim().length <= maxLength;
  }

  /**
   * Check if value is within range
   */
  isInRange(value, min, max) {
    const num = parseInt(value);
    return num >= min && num <= max;
  }

  /**
   * Sanitize string input
   */
  sanitizeString(str) {
    return str.trim().replace(/[<>]/g, "");
  }

  /**
   * Format phone number
   */
  formatPhone(phone) {
    return phone
      .replace(/\D/g, "")
      .replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3");
  }
}

export const validators = new Validators();
export default validators;
